import { useEffect } from 'react'
import { useSetAtom } from 'jotai'
import { contactCaseCountAtom } from 'pages/Contacts/atoms/contactAtoms'
import { useContactCaseCountQuery } from './queries/useContactCaseCountQuery'

export const useContactCaseCount = (isEnabled?: boolean) => {
  const setContactCaseCount = useSetAtom(contactCaseCountAtom)
  const { data: contactCaseCount } = useContactCaseCountQuery(isEnabled)

  const numberOfContactCases = contactCaseCount?.count

  useEffect(() => {
    setContactCaseCount(numberOfContactCases)
  }, [numberOfContactCases])
}
